// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"587":"1a67bf25","783":"3439be17"}[chunkId] + ".chunk.css";
};